<div class="w-100 jlp-container-location">
    <rask-date-drill-down
        [periodFrom]="settings.periodFrom"
        [periodTom]="settings.periodTom"
        [parent]="this">

        <rask-checkbox
            aid="checkboxVisaTakt"
            text="Takt {{ dagarKvarInnevarandeManad(settings) }} av {{ settings.totaltAntalArbetsdagarInnevarandeManad }} dgr kvar på inn. mån."
            [(checked)]="showTakt"
            (click)="toggleTakt()"
            class="taktCheckbox">
        </rask-checkbox>

        <rask-hot-doc
            [canEdit]="canEdit"
            [hotDoc]="hotDoc">
        </rask-hot-doc>
    </rask-date-drill-down>

    <rask-footer id="pageFooterJpl" class="page-footer jpl-page-footer">
        <ng-container footerContent>
            <rask-button
                id="saveJpl"
                raskHotkey="ctrl+s"
                color="primary"
                (click)="save()"
                [disabled]="!canSave()"
                placement="left"
                ngbTooltip="{{('DEFAULT_BUTTON_LABEL_SPARA' | translate) }} {{'DEFAULT_HOTKEYS_CONTROL_S' | translate}}">
                {{ 'DEFAULT_BUTTON_LABEL_SPARA' | translate }}
            </rask-button>
        </ng-container>
    </rask-footer>
</div>
